const Auth = {};

import { mapState, mapActions } from 'vuex'

Auth.install = function(Vue, options) {


    Vue.mixin({
        computed: {
            ...mapState([
                'authenticated',
                'userData'
            ])
        },
        methods: {
            ...mapActions([
                'StoreAuthStatus',
                'StoreGuestNumber',
                'StoreNumber',
                'StoreUserData',
                'UserLogout',
                'notificationCount',
                'activeLoading',
                'toggleSidebar',
                'changeSidebarState',
                'StoreNotifications',
                'StoreSetting',
                'StoreBankAccounts',
                'StorePrice',
                'StoreWallets',
            ]),
            checkAuth() {
                const api_token = this.$cookies.get("api_token");

                if (!api_token) {
                    this.$router.replace({ name: 'LoginByPassword' })
                }
                return true;
            },
            checkUnAuthenticated() {
                const api_token = this.$cookies.get("api_token");

                if (api_token) {
                    this.$router.replace({ name: 'Dashboard' })
                }
            },
            getToken() {
                const api_token = this.$cookies.get("api_token");

                return api_token;
            },
            checkIsAuthenticated() {
                const api_token = this.$cookies.get("api_token");

                if (api_token) {
                    return true
                } else {
                    return false
                }
            },
            checkConfirmed() {
                if (this.authenticated) {
                    const status = this.userData.user_detail.user_status;
                    if (!this.userData.has_password) { this.$router.replace({ name: 'SetPassword' }) }
                    if (status !== 2) { this.$router.replace({ name: 'Dashboard' }) }
                }
            },
            authUser(data) {

                this.StoreAuthStatus(true)
                this.StoreUserData(data.user)

                const user_status = data.user.user_detail.user_status;

                const authLevel = this.$route.meta.authLevel;
                switch (authLevel) {
                    case 2:
                        this.$router.replace({ name: 'Dashboard' })
                        break;
                    case 3:
                        if (user_status == 1 || user_status == 2) {
                            this.$router.replace({ name: 'Dashboard' })
                        }
                        break;
                    case 5:
                        if (user_status == 0 || user_status == 3) {
                            this.$router.replace({ name: 'Authentication' })
                        }
                        break;
                    default:
                }

                this.notificationCount(data.notifications_count)
                this.StoreNotifications(data.notifications)
                this.StoreBankAccounts(data.bank_accounts)
                this.StoreWallets(data.wallets)

            },
        }
    });



};

export { Auth as default };